// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion: 'v8.0.24',
  mainHost: 'localhost:4200',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: true,
  apiUrl: 'https://your-domain.com/api',
  appThemeName: 'Metronic',
  appPurchaseUrl: 'https://1.envato.market/EA4JP',
  appPreviewUrl: 'https://preview.keenthemes.com/metronic8/angular/demo1/',
  appPreviewAngularUrl: 'https://preview.keenthemes.com/metronic8/angular',
  appPreviewDocsUrl:
    'https://preview.keenthemes.com/metronic8/angular/demo1-docs',
  appPreviewChangelogUrl:
    'https://preview.keenthemes.com/metronic8/angular/demo1-docs/docs/changelog',
  appLandingPage: undefined,

  backendBaseUrl: 'https://stg-api-gateway.e.external.techadshero.pl/v1',
  backendBaseUrlV2: 'https://stg-api-gateway.e.external.techadshero.pl/v2',
  backendBaseUrlV3: 'https://stg-api-gateway.e.external.techadshero.pl/v3',
  backendBaseUrlV4: 'https://stg-api-gateway.e.external.techadshero.pl/v4',

  billingBaseUrl: 'https://stg-api-gateway.e.external.techadshero.pl/billing/v1',

  keycloakBaseUrl: 'https://tst-keycloak.prx.techadshero.pl',
  keycloakRealm: 'AdServiceStg',
  keycloakClientId: 'frontend-service',

  regulationsUrlEn: undefined,
  regulationsUrlPl: undefined,

  // Disable Sentry for local env
  sentryDsn: '',
  sentryTracesSampleRate: 1.0,

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
